import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/use-intl.esm.js';
import React, { useState } from 'react';
import IntlContext from './use-intl.esm9.js';
import getInitializedConfig from './use-intl.esm10.js';

var _excluded = ["children"];
function IntlProvider(_ref) {
  var children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useState = useState(function () {
      return new Map();
    }),
    messageFormatCache = _useState[0];
  return React.createElement(IntlContext.Provider, {
    value: _extends({}, getInitializedConfig(props), {
      messageFormatCache: messageFormatCache
    })
  }, children);
}

export { IntlProvider as default };
//# sourceMappingURL=use-intl.esm.js.map
